import React, { useState } from 'react';
import {Formik, Form} from 'formik';
import {
  Grid,
  Button,
  TextField,
  Box,
} from '../../../components/shared/MaterialUI';
import {validationSchema} from './validationSchema';
import {SelectField} from "../../../forms";
import {UsZipsService} from "../../../services";
import {useUI} from "../../../app/context/ui";

const usZipsService = new UsZipsService();
const ZipForm = ({initialValues, onSubmit, classes, setOpenModal, states, typeModal}) => {
  const {blockUI} = useUI();

  const handleZipBlur = async (e, setFieldValue) => {
    const zip = e.target.value;
    if (zip.length === 5) {
      try {
        blockUI.current.open(true);
        usZipsService.getAccessToken();
        const r1 = await usZipsService.zipCode(zip);
        setFieldValue('isValidated', r1.data.exists === 1 || r1.data.exists === '1');
        setFieldValue('city', r1.data.city);
        setFieldValue('stateId', r1.data.stateId);
        blockUI.current.open(false);
      } catch (error) {
        blockUI.current.open(false);
      } finally {
        blockUI.current.open(false);
      }
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({values, touched, errors, handleChange, setFieldValue}) => (
        <Form autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={3} className={classes.grdItem}>
              <label>Zipcode:</label>
            </Grid>
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                autoFocus
                fullWidth
                id="zip"
                name="zip"
                value={values.zip}
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === '' || re.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                onBlur={(e) => typeModal === 'Add' ? handleZipBlur(e, setFieldValue) : ''}
                error={touched.zip && Boolean(errors.zip)}
                helperText={touched.zip && errors.zip}
                className={classes.inputCustom}
                inputProps={{inputMode: 'numeric', pattern: '[0-9]*', maxLength: 5}}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3} className={classes.grdItem}>
              <label>City:</label>
            </Grid>
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                id="city"
                name="city"
                value={values.city || ''}
                onChange={handleChange}
                error={Boolean(touched.city && errors.city)}
                helperText={touched.city && errors.city}
                placeholder="City"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3} className={classes.grdItem}>
              <label>State:</label>
            </Grid>
            <Grid item xs={9}>
              <SelectField
                name="stateId"
                data={states}
                onChange={handleChange}
                placeholder="-- Select a State --"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3} className={classes.grdItem}>
              <label>Exceptions:</label>
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                minRows={4}
                variant="outlined"
                fullWidth
                name="exceptions"
                value={values.exceptions}
                onChange={handleChange}
                error={touched.exceptions && Boolean(errors.exceptions)}
                helperText={touched.exceptions && errors.exceptions}
              />
            </Grid>
          </Grid>
          <Box pb={2}/>
          <Grid container justifyContent="center">
            <Button
              variant="contained"
              size="large"
              className={classes.button}
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              className={classes.button}
            >
              Save
            </Button>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
export default ZipForm;
